var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8846 8.25142V5.82312H17.3129V8.25142H14.8846ZM13.0633 8.25142C13.0633 9.25689 13.8791 10.0726 14.8846 10.0726H17.3129C18.3183 10.0726 19.1341 9.25689 19.1341 8.25142V5.82312C19.1341 4.81765 18.3183 4.0019 17.3129 4.0019H14.8846C13.8791 4.0019 13.0633 4.81765 13.0633 5.82312V8.25142ZM7.6376 4.26749C7.28094 3.91084 6.70422 3.91084 6.35136 4.26749L2.70511 7.90994C2.34846 8.2666 2.34846 8.84332 2.70511 9.19618C3.06177 9.54905 3.63849 9.55284 3.99136 9.19618L6.07818 7.10936L6.08197 20.0894C6.08197 20.594 6.48795 21 6.99258 21C7.49721 21 7.9032 20.594 7.9032 20.0894V7.10936L9.99002 9.19618C10.3467 9.55284 10.9234 9.55284 11.2763 9.19618C11.6291 8.83953 11.6329 8.26281 11.2763 7.90994L7.6376 4.26749ZM14.8846 14.3222H19.7412V19.1788H14.8846V14.3222ZM13.0633 14.3222V19.1788C13.0633 20.1842 13.8791 21 14.8846 21H19.7412C20.7466 21 21.5624 20.1842 21.5624 19.1788V14.3222C21.5624 13.3167 20.7466 12.5009 19.7412 12.5009H14.8846C13.8791 12.5009 13.0633 13.3167 13.0633 14.3222Z",
    fill: "#040404"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/orderIcon.0797cfabc3ba11018ea2d436edff463a.svg";
export { ForwardRef as ReactComponent };